import { createFileRoute, Outlet } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'

export const Route = createFileRoute('/(private)/bando/$residenceId/domande')({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin-applications:page_title'
				)
			}
		]
	}),
	staticData: {
		breadcrumb: 'admin-applications:page_title'
	},
	component: () => <Outlet />
})
